<template>
  <g
    id="Front_Left_Indicator"
    v-on:click="changeSeverity('rearFrontLeftIndicator')"
    :class="severityClass"
  >
    <rect
      class="cls-899"
      x="76.11"
      y="245.93"
      width="9.27"
      height="2.23"
      transform="translate(161.5 494.1) rotate(180)"
    />
    <g>
      <circle
        class="cls-208"
        cx="88.59"
        cy="247.05"
        r="5.2"
        transform="translate(-148.74 135) rotate(-45)"
      />
      <circle
        class="cls-458"
        cx="88.59"
        cy="247.05"
        r="5.09"
        transform="translate(-148.74 135) rotate(-45)"
      />
      <circle class="cls-170" cx="88.59" cy="247.05" r="4.98" />
      <circle class="cls-300" cx="88.59" cy="247.05" r="4.87" />
      <circle class="cls-135" cx="88.59" cy="247.05" r="4.76" />
      <circle class="cls-301" cx="88.59" cy="247.05" r="4.65" />
      <circle class="cls-403" cx="88.59" cy="247.05" r="4.54" />
      <circle class="cls-363" cx="88.59" cy="247.05" r="4.43" />
      <circle class="cls-364" cx="88.59" cy="247.05" r="4.32" />
      <circle class="cls-31" cx="88.59" cy="247.05" r="4.22" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
